import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']
  declare itemTargets: HTMLElement[]

  activate (e: Event): void {
    const target = e.currentTarget as HTMLElement
    for (const item of this.itemTargets) item.classList.remove('active')
    target.classList.add('active')
  }
}
